// extracted by mini-css-extract-plugin
export default {"desktopTopBar":"DesktopTopBarContents_desktopTopBar__R6Sas","contactInfo":"DesktopTopBarContents_contactInfo__4lRkV","spacer":"DesktopTopBarContents_spacer__0981N"};